<template>
  <div class="boomerang-logo">
    <img src="@/assets/boomerang_black_logo.png" alt="Boomerang" />
  </div>
</template>

<style scoped>
.boomerang-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}
img {
  width: 100%;
}
</style>
